import { connection } from '@/api/connection'

export default {
  getCreditContractTerms: ({ contractId }) => connection.get(`bo/contracts/${contractId}/terms/detail`),
  postCreditContractTerms: ({ contractId, termsData }) => connection.post(`bo/contracts/${contractId}/terms/detail`, termsData)
}
